import axiosClient from '../../../config/axios-client'

const ReviewerService = {
  getReviewers(queryString) {
    return axiosClient.get(`/dashboard/reviewers?${queryString}`)
  },
  getReviewer(reviewerId) {
    return axiosClient.get(`/dashboard/reviewers/${reviewerId}`)
  },
  getReviewersStatistics() {
    return axiosClient.get(`/dashboard/reviewers/statistics`)
  },
}

export default ReviewerService
